var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DisplaceDetail',{ref:"displaceDetail",attrs:{"id":_vm.contractId,"allowEdit":""},on:{"addCommodity":_vm.handleAddCommodity,"editCommodity":_vm.handleEditCommodity}}),_c('ModifyCommodity',{ref:"modifyCommodity",on:{"on-success":_vm.hanldeModifySuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }